<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">我的创作</h1>
      <p class="hint">您创建的测评与课程；编辑入口请前往管理后台对应模块。</p>

      <el-tabs v-model="tab">
        <el-tab-pane label="测评" name="exam">
          <el-table :data="exams" v-loading="loading" empty-text="暂无测评">
            <el-table-column prop="examName" label="名称" min-width="160" />
            <el-table-column prop="examSname" label="简称" width="120" />
            <el-table-column label="定价（元）" width="100">
              <template #default="s">{{ (s.row.fee / 100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template #default="s">
                <el-button link type="primary" @click="$router.push(`/admin/exam/edit/${s.row.id}`)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="课程" name="course">
          <el-table :data="courses" v-loading="loading" empty-text="暂无课程">
            <el-table-column prop="name" label="名称" min-width="160" />
            <el-table-column prop="category" label="分类" width="120" />
            <el-table-column label="定价（元）" width="100">
              <template #default="s">{{ (s.row.fee / 100).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template #default>
                <el-button link type="primary" @click="$router.push('/admin/knowledge/courses')">管理</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { fetchMyCreations } from '@/utils/userHub'

export default {
  name: 'MyCreationsView',
  data() {
    return {
      tab: 'exam',
      loading: false,
      exams: [],
      courses: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const data = await fetchMyCreations()
        this.exams = data.exams || []
        this.courses = data.courses || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
</style>
